import { QUERY_PARAMS } from "../constants/storage.constants";
import { GenericObject } from "../types/common.types";
import { getFromLocal } from "./storage.util";

export const allowedUTMParamsList = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_id",
  "utm_term",
  "utm_content",
  "utm_device",
  "utm_adgroup",
  "ref",
];
const utmPropSet = new Set(allowedUTMParamsList);

export const getUTMFieldsFromLocalStorage = (): GenericObject => {
  const utmFieldsInLocalStorage = getFromLocal("utmFields") || {};
  if (typeof utmFieldsInLocalStorage === "string") return {};

  const utmFields: GenericObject = {};
  for (let [key, val] of Object.entries(utmFieldsInLocalStorage)) {
    if (utmPropSet.has(key)) {
      utmFields[key] = val;
    }
  }
  return utmFields;
};

export const extractParamsFromObj = (obj: GenericObject) => {
  const utmFields: GenericObject = {};
  let gref;
  const otherParams: GenericObject = {};
  for (let [key, val] of Object.entries(obj)) {
    if (utmPropSet.has(key)) {
      utmFields[key] = val;
    } else if(key === "q") {
      utmFields['utm_campaign'] = val
    } else if(key === "gclid") {
      localStorage.setItem("gclid", String(val))
      utmFields['utm_content'] = val
      const queryParams = (getFromLocal(QUERY_PARAMS) || {}) as GenericObject;
      queryParams.gclid = val;
      localStorage.setItem(QUERY_PARAMS, JSON.stringify(queryParams));
    } else if(key === "matchtype") {
      localStorage.setItem("matchtype", String(val))
      const queryParams = (getFromLocal(QUERY_PARAMS) || {}) as GenericObject;
      queryParams.matchtype = val;
      localStorage.setItem(QUERY_PARAMS, JSON.stringify(queryParams));
    } else if(key === "device") {
      localStorage.setItem("device", String(val))
      const queryParams = (getFromLocal(QUERY_PARAMS) || {}) as GenericObject;
      queryParams.device = val;
      localStorage.setItem(QUERY_PARAMS, JSON.stringify(queryParams));
    }
    else if (key === "gref") {
      gref = val;
    } else {
      otherParams[key] = val;
    }
  }
  return { utmFields, gref, otherParams };
};

export const stringifyUTMParams = (
  obj: GenericObject,
  hideAmpersand?: boolean
): string => {
  let utmString: string = "";
  for (const [index, [key, value]] of Object.entries(Object.entries(obj))) {
    if (Number(index) === Object.keys(obj).length - 1 && hideAmpersand) {
      utmString += `${key}=${value}`;
    } else {
      utmString += `${key}=${value}&`;
    }
  }
  return utmString;
};
